import Link from 'next/link';
import { ComponentProps } from 'react';

export default function TransCompatibleLink({
  children,
  ...props
}: ComponentProps<typeof Link>): JSX.Element {
  let validChildren = children;
  // work around for the react-18next Trans component
  if (Array.isArray(children) && children.length === 1 && typeof children[0] === 'string') {
    [validChildren] = children;
  }

  return (
    <Link {...props} legacyBehavior>
      {validChildren}
    </Link>
  );
}
